// Nickname editor (design §4.6): prefilled with the generated fallback name and
// a dice button next to it. Skipping is a valid outcome — the fallback name is
// meant to be keepable.

import { rerollNickname, setNickname } from '../api';
import { t } from '../i18n';
import { el } from './dom';

export interface NicknameOptions {
  initial: string;
  onChanged?: (nickname: string) => void;
}

export function nicknameEditor(opts: NicknameOptions): HTMLElement {
  const input = el('input', {
    class: 'nick-input',
    attrs: {
      type: 'text',
      maxlength: '24',
      autocomplete: 'off',
      autocapitalize: 'off',
      spellcheck: 'false',
      placeholder: t('nickname.placeholder'),
      'aria-label': t('nickname.title'),
    },
  });
  input.value = opts.initial;

  const msg = el('div', { class: 'nick-msg' });
  const dice = el('button', {
    class: 'nick-btn',
    text: '🎲',
    attrs: { type: 'button', title: t('nickname.reroll'), 'aria-label': t('nickname.reroll') },
  });
  const save = el('button', {
    class: 'nick-btn',
    text: t('nickname.save'),
    attrs: { type: 'button' },
  });

  const setMsg = (text: string, error = false): void => {
    msg.textContent = text;
    msg.classList.toggle('nick-msg--err', error);
  };

  dice.addEventListener('click', () => {
    dice.disabled = true;
    void rerollNickname()
      .then((res) => {
        if (res.nickname) {
          input.value = res.nickname;
          setMsg('');
          opts.onChanged?.(res.nickname);
        } else if (res.error) {
          setMsg(res.error, true);
        }
      })
      .catch(() => setMsg(t('nickname.error'), true))
      .finally(() => {
        dice.disabled = false;
      });
  });

  save.addEventListener('click', () => {
    const value = input.value.trim();
    if (!value) return;
    save.disabled = true;
    void setNickname(value)
      .then((res) => {
        input.value = res.nickname || value;
        setMsg(t('nickname.saved'));
        opts.onChanged?.(input.value);
      })
      .catch(() => setMsg(t('nickname.error'), true))
      .finally(() => {
        save.disabled = false;
      });
  });

  return el('div', { class: 'nick' }, [
    el('div', { class: 'nick-label', text: t('nickname.title') }),
    el('div', { class: 'nick-row' }, [input, dice, save]),
    msg,
  ]);
}
